export function HeplSlider() {
    const $slider = $(".help-slider");
    const WIN = $(window);
    const $prev = $slider.parent(".help-slider-holder").find(".prev");
    const $next = $slider.parent(".help-slider-holder").find(".next");
    const point = 767;
    let destroy = true;
    let windowWidth;
    windowWidth = detectWindowWidth();
    $slider.on("init reInit", function (event, slick, currentSlide, nextSlide) {
        slick.$dots.find("button").each(function (i, el) {
            let class_name = slick.$slides
                .find(".slide")
                .eq(i)[0]
                .className.split(' ')
                .filter(el => el.indexOf("circle") !== -1)
                .join('');
            if (class_name.length) {
                $(el).addClass(class_name);
            }
        });
    });
    slideDetect();

    WIN.on("resize", function () {
        windowWidth = detectWindowWidth();
        slideDetect();
    });

    function detectWindowWidth() {
        return WIN.innerWidth();
    }
    function slideDetect() {
        if (windowWidth < point && destroy) {
            $slider.slick({
                dots: true,
                arrows: true,
                infinite: false,
                draggable: true,
                slidesToScroll: 1,
                slidesToShow: 1,
                mobileFirst: true,
                prevArrow: $prev,
                nextArrow: $next,
            });
            destroy = false;
        } else if (windowWidth > point && !destroy) {


            $slider.slick("unslick");

            destroy = true;
        }
    }
}



// WEBPACK FOOTER //
// ./assets/js/modules/HelpSlider.js